<template>
  <section class="workspacemodel-versionhistory">
    <h4 class="mb-2">{{ $t("headings.modelVersions") }}</h4>
    <ul v-if="sortedVersions.length > 0">
      <li v-for="version in sortedVersions" :key="version.id">
        {{ formatDateString(version.created) }} –
        {{ version.creator?.name ?? $t("labels.unknownUser") }}
        <!-- – {{ formatSize(version.size) }} -->
      </li>
    </ul>
    <p v-else class="message message-info mt-0">
      {{ $t("messages.modelHasNoSaveStates") }}
    </p>
  </section>
</template>

<script setup lang="ts">
import { ref, computed, watch } from "vue";
import { formatDate } from "@/i18n";
import { useUser } from "@/api/user.store";
import { useModels } from "@/api/models.store";

import type { User } from "@/api/User";

const props = defineProps<{
  modelId: number | string;
}>();

const { getKnownUsers } = useUser();
const { currentModel, loadModelVersionHistory } = useModels(props);
  
const knownUsers = ref<User[]>([]);

const versions = computed(() => {
  return currentModel.value?.versions ?? [];
});

const sortedVersions = computed(() => {
  const sortedArray = versions.value.slice(0);
  sortedArray.sort((a, b) => {
    if (a.created == b.created) return 0;
    if (a.created < b.created) return 1;
    else return -1;
  });
  return sortedArray;
});

watch(() => currentModel.value?.id, (value) => {
  if (currentModel.value) {
    loadModelVersionHistory(currentModel.value).catch((error) => {
      console.warn("could not read online version history", error);
    });
  }
}, { immediate: true });

getKnownUsers(true)
  .then((users) => (knownUsers.value = users))
  .catch((error) => {
    console.warn("error getting known users", error);
  });

function formatDateString(dateString: string) {
  const date = new Date(dateString);
  return formatDate(date, "yyyy-LL-dd HH:mm");
}

// function formatSize(bytes: number): string {
//   if (bytes < 1024) return bytes + " B";
//   else if (bytes < 1024 * 1024) return (bytes / 1024).toFixed(1) + " KB";
//   else if (bytes < 1024 * 1024 * 1024)
//     return (bytes / (1024 * 1024)).toFixed(1) + " MB";
//   else return (bytes / (1024 * 1024 * 1024)).toFixed(1) + " GB";
// }
</script>

<style></style>
